import React, { useState,useEffect } from 'react';
import './css/invoice.css';
import { useNavigate, useParams } from 'react-router-dom';
import {FaDownload} from'react-icons/fa';
import { API_URL_BASE } from './config';

const  Invoice = ()  => {
	const [userId, setUserid] = useState('');
	const [token, setToken] = useState('');
	const [message, setMessage] = useState('');
	const [invoiceResult, setInvoiceResult] = useState('');
	const navigate = useNavigate();


	// Step 1: Set tokenId from localStorage
	useEffect(() => {
	  const storedToken = localStorage.getItem('token');
	  if (storedToken) {
	    setToken(storedToken);
	  } else {
	    // Optional: redirect to login or show fallback
	    console.warn("No token found in localStorage");
	navigate("/");
	  }
	}, []);
	
	useEffect(() => {
		if (!token) return;
		console.log("fetch invoice");
		fetchInvoice();
		},[token]);

	const fetchInvoice = () => {
	    fetch(API_URL_BASE + `/ticket.json`, {
	      method: "POST",
	      headers: {
	        "Content-Type": "application/json",
	      },
	      body: JSON.stringify({
	        fetchInvoice: {
	          token: token,
	          id: userId,
	        },
	      }),
	    })
	      .then((res) => {
	        if (!res.ok) throw new Error("Event not found");
	        return res.json();
	      })
	      .then((data) => {
			console.log(data.invoices);
	        setInvoiceResult(data.invoices);
	      })
	      .catch((err) => {
	        console.error("Error loading event:", err);
	        setInvoiceResult(null);
	      })
	      .finally();
	  };
	
  return (
	<div>	 	
	<h2>Invoice</h2>
		<div className="eventdetails-table-responsive">	     
	   <table className="eventdetails-ticket-table">
	       <thead>
	           <tr>
	               <th> Invoice No</th>
				   <th> Invoice Date </th>
	               <th> Date</th>
				   <th></th>
	           </tr>
	       </thead>
	       <tbody>
	               <tr key="1">
	                   <td>Invoiceno</td>
					   <td>Invoicedate</td>	
	                   <td>status</td>	
					   <td><FaDownload/></td>			 
	               </tr>
	       </tbody>
	   </table>
	 	</div>
	 </div>
  );
  
}

export default Invoice;